
import { ViewCell, Cell, DefaultEditor, Editor } from 'ng2-smart-table';
import { Component, OnInit } from '@angular/core';




/**
 * Componente que renderiza la celda ID en la tabla de customform
 */
@Component({
  template: `
  <input  type="text" nbInput fullWidth id="valorCampo" disabled name="valorCampo" [(ngModel)]="currentValue"/>
  `,
})
export class IdPropertyComponent extends DefaultEditor implements OnInit {
  currentValue: any;
  ngOnInit(): void {
    this.currentValue = this.cell.getValue();
  }

}
